import React from 'react';
import { HomeGroupLayout, HomeVideoHistoryTable } from 'components';


/**
 * 查看學生觀看紀錄頁面
 */

export const HomeVideoHistoryTablePage = () => {
  return (
    <HomeGroupLayout>
      <HomeVideoHistoryTable />
    </HomeGroupLayout>
  );
};
